import { EmailsettingsService } from './../../_services/emailsettings.service';
import { Component, OnInit, ViewChild, TemplateRef, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl } from '@angular/forms';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/_services/global.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';

@Component({
  selector: 'app-edit-email-template',
  templateUrl: './edit-email-template.component.html',
  styleUrls: ['./edit-email-template.component.scss']
})
export class EditEmailTemplateComponent implements OnInit {
  editecompanydetail: FormGroup;
  email: any;
  templateid: any;
  companynumber: any;
  successMessage: string;
  errorMessage: string;
  updatedEmailValues: any;
  checboxvalue: any;
  range: any;
  sel: Selection;
  attachedfile: any;
  attachedfilename: any;
  placeid: boolean;
  placeholderlist: any;
  InputtoEdit: any;


  @ViewChild("success") success: TemplateRef<any>;
  @ViewChild("error") error: TemplateRef<any>;
  @ViewChild('subject') subject: ElementRef;

  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "10rem",
    minHeight: "5rem",
    placeholder: "Please enter job description.",
    translate: "no",
    uploadUrl: "v1/images", // if needed
    customClasses: [
      // optional
      {
        name: "quote",
        class: "quote"
      },
      {
        name: "redText",
        class: "redText"
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1"
      }
    ],
    toolbarHiddenButtons: [[
      'fontSize',
      'insertVideo',
      'fontName',
      'heading',
      'customClasses'
    ]
    ]
  };

  constructor(private modalService: NgbModal,
    private fb: FormBuilder,
    private emailsetting: EmailsettingsService, private _localstorageservice : LocalStorageService) { }

  ngOnInit() {

    this.editecompanydetail = this.fb.group({
      subject: [this.email ? this.email.subject : "",[Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      template: [this.email ? this.email.template : "", [Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)]],
      actionname: [this.email ? this.email.actionname : "", [Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)]]
    });

    this.editecompanydetail.controls.template.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      res = res ? res.replace(/<[^>]*>?/gm, '').toLowerCase() : ''
      if (res && (res.includes('onerror') || res.includes('prompt') || res.includes('src') || scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))) {
        this.editecompanydetail.patchValue({
          template: ""
        }, { emitEvent: false })
        this.editecompanydetail.get('template').setErrors({ 'scriptTagError': true })
      }else{
        this.editecompanydetail.get('template').setErrors(null)
      }
    })

    

    if (this.email) {
      this.getCustomTemplate();
    }

    function noWhitespaceValidator(control: AbstractControl) {
      if(control && control.value){
        const isWhitespace = (control.value.replace(/&#160;/g,'') || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'required': true };
      }
  }
    
    this.placeholderlist = GlobalService.placeholderlist;

  }

  testscript() {
    this.editecompanydetail.controls.template.valueChanges.subscribe((res:any)=>{
      let scriptRegex = /&lt;script(.*)&gt;/g;
      let scriptRegex1 = /<script(.*)>/g;
      if(res && (scriptRegex.test(res.trim()) == true || scriptRegex1.test(res.trim()) == true || res.includes('src='))){
        this.editecompanydetail.get('template').setErrors({ 'scriptTagError': true })
      }else{
        this.editecompanydetail.get('template').setErrors(null)
      }
    })
  }

  getCustomTemplate() {
    this.emailsetting.getEmailDetails(this.email.templateid,this._localstorageservice.getItem('usernumber'))
      .subscribe((res: any) => {
        if (res.status == "success") {
          this.email = res.message[0];
          this.editecompanydetail.patchValue({
            subject: this.email.subject,
            template: this.email.template,
            actioname: this.email.actioname
          });
        } else {
          console.log("Something went Wrong");
        }

        this.editecompanydetail.valueChanges.subscribe((email: any) => {
          this.updatedEmailValues = email;
          return email;
        });
      });
  }

  dismiss() {
    this.modalService.dismissAll();
  }


  //Placeholder
  selectplaceholder(event: any) {
    this.checboxvalue = event.target.value;
    if (this.range) {
      if (this.InputtoEdit == 'body') {
        var el = document.createElement("div");
        el.innerHTML = ('<span class="nonEdit"> {{' + this.checboxvalue + '}} </span>');
        var frag = document.createDocumentFragment(), node, lastNode;
        while ((node = el.firstChild)) {
          lastNode = frag.appendChild(node);
        }
        this.range.insertNode(frag);
        // let text = document.getElementById('editor').innerHTML;
        // this.editecompanydetail.patchValue({ template: text })
        let elem = document.getElementsByClassName('ql-editor')[0];//This is the element that you want to move the caret to the end of
        this.setEndOfContenteditable(elem);
      } else if (this.InputtoEdit == 'subject') {
        var startPos = this.subject.nativeElement.selectionStart;
        this.subject.nativeElement.focus();
        this.subject.nativeElement.value = this.subject.nativeElement.value.substr(0, this.subject.nativeElement.selectionStart) + '{{' + this.checboxvalue + '}}' +
          this.subject.nativeElement.value.substr(this.subject.nativeElement.selectionStart, this.subject.nativeElement.value.length);
        this.subject.nativeElement.selectionStart = startPos;
        this.editecompanydetail.patchValue({ subject: this.subject.nativeElement.value })
      }
    }
    this.checboxvalue = ''
    this.placeid = false
  }


  setEndOfContenteditable(contentEditableElement) {
    var range, selection;
    if (document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
      range = document.createRange();//Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
      range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection();//get the selection object (allows you to change selection)
      selection.removeAllRanges();//remove any selections already made
      selection.addRange(range);//make the range you have just created the visible selection
    }
  }
  
  getCursorPosition(type) {
    this.InputtoEdit = type
    this.sel = window.getSelection();
    if (this.sel.getRangeAt && this.sel.rangeCount) {
      this.range = this.sel.getRangeAt(0);
      this.placeid = true
    }
  }


  updatetemp() {
    if (this.editecompanydetail.valid) {
      //update
      if (this.email && this.email.templateid) {
        if (this.updatedEmailValues) {
          let updatedFields = {};
          let activitylog = [];
          Object.keys(this.updatedEmailValues).map(updatekey => {
            Object.keys(this.email).map(branchkey => {
              if (updatekey === branchkey) {
                if (
                  this.updatedEmailValues[updatekey] !== this.email[branchkey]
                ) {
                  updatedFields[updatekey] = this.updatedEmailValues[updatekey];
                  activitylog.push({
                    action: "'update'",
                    tablename:  "'emailtemplate'",
                    primarykeyid: this.email.templateid,
                    updatedfieldname: "'" +  updatekey + "'",
                    oldvalue: this.email[branchkey] == null ? null :"'" + this.email[branchkey] + "'",
                    newvalue: this.updatedEmailValues[updatekey] == null ? null : "'" +  this.updatedEmailValues[updatekey] + "'",
                    type: "'custom'",
                    createdby: "'" + this._localstorageservice.getItem('usernumber') + "'",
                    userid: "'" + this._localstorageservice.getItem('usernumber') + "'",
                    usertype: "'user'",
                  });
                }
              }
            });
          });
          let data = {
            template: {
              ...updatedFields,
               templateid: this.email.templateid,
               updatedby: this._localstorageservice.getItem('usernumber')
            },
            activitylog: activitylog,
            
          };

          this.emailsetting.updateEmailList(data).subscribe((res: any) => {
            if (res.status === "success") {
              this.modalService.dismissAll();
              this.passEntry.emit('modify');
            }
            else {
              this.passEntry.emit('error');
            }
          });
        }
      } else {
        //create
        let data = {
          template: {
            userid: this._localstorageservice.getItem('usernumber'),
            action: this.editecompanydetail.value.actionname,
            actionname: this.editecompanydetail.value.actionname,
            template: this.editecompanydetail.value.template,
            subject: this.editecompanydetail.value.subject,
            description: "desc",
            type: "custom",
            createdby: this._localstorageservice.getItem('usernumber'),
            updatedby: this._localstorageservice.getItem('usernumber'),
          },
          activitylog: [{
            action: "'create'",
            tablename: "'emailtemplates'",
            newvalue: "'new'",
            type: "'custom'",
            usertype: "'create'",
            createdby: "'" + this._localstorageservice.getItem('usernumber') + "'",
            userid: "'" + this._localstorageservice.getItem('usernumber') + "'"
          }]
        };
        this.emailsetting.createCustomEmail(data).subscribe((res: any) => {
          if (res.status === "success") {
            this.successMessage = "Email Template Created successfully";
            this.modalService.dismissAll();
            this.passEntry.emit('added');
          } else {
            this.passEntry.emit('error');
          }
        });
      }
    } else {
      this.validateAllFormFields(this.editecompanydetail);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  passBack() {
    this.passEntry.emit('email-edited');
  }

}





